module.exports = __webpack_public_path__ + "static/img/9.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/8/zh/9.png
// module id = v7dI
// module chunks = 0